import { render, staticRenderFns } from "./GisEffort.vue?vue&type=template&id=60a79bf8&"
import script from "./GisEffort.vue?vue&type=script&lang=js&"
export * from "./GisEffort.vue?vue&type=script&lang=js&"
import style0 from "./GisEffort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports